import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'CommonInput',
  props: {
    modelValue: { type: String, required: true },
    label: { type: String, required: false },
    supportingText: { type: [String, null], required: false },
    state: { type: String, required: false },
    type: { type: String, required: false }
  },
  emits: ["update:model-value", "tap-trailing", "leave-focus", "key-down", "on-paste"],
  setup(__props: any, { expose: __expose }) {

_useCssVars(_ctx => ({
  "4ccce1c2-inputBackgroundColor": (inputBackgroundColor),
  "4ccce1c2-inputBorderColor": (inputBorderColor)
}))

const props = __props;



__expose({
  setFocus: (v: boolean) => v ? inputField.value?.focus() : inputField.value?.blur(),
});

const state = props.state ?? 'default';

const isFocused = ref(false);
const isHovered = ref(false);
const floatOn = computed(() => isFocused.value || props.modelValue.length > 0)
const inputField = ref<HTMLInputElement | null>(null);
const inputBorderColor = `var(--token-input-${state}-border-color)`;
const inputBackgroundColor = `var(--token-input-${state}-background-color)`;

function getState() {
  if(isHovered.value && state != "disabled") {
    return "-hovered";
  }
  if(isFocused.value && state == "default") {
    return "-focused";
  }
  return `-${state}`;
}

onMounted(() => {
  inputField.value!.onkeyup = () => {
    inputField.value?.blur();
    inputField.value?.focus();
  };
});

const __returned__ = { props, state, isFocused, isHovered, floatOn, inputField, inputBorderColor, inputBackgroundColor, getState }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})